import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  NumberInput,
  useRedirect,
  useNotify,
  useRecordContext,
} from 'react-admin';
import { Box, Typography } from '@mui/material';
import ResourceBreadcrumbsWithActions from '../../components/ResourceBreadcrumbsWithActions';

const BrandEditTitle = () => {
  const record = useRecordContext();
  if (!record) return 'Loading...';
  return `Edit: ${record.name}`;
};

export const BrandEdit = () => {
  const redirect = useRedirect();
  const notify = useNotify();

  const handleSuccess = () => {
    notify('Brand updated successfully');
    redirect('/brands');
  };

  return (
    <Edit resource="brands" redirect={false} onSuccess={handleSuccess} title={<BrandEditTitle />}>
      <SimpleForm>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
            Edit Brand
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Update brand information and settings
          </Typography>
        </Box>

        <TextInput
          source="name"
          label="Brand Name"
          validate={[{ required: 'Brand name is required' }]}
          fullWidth
        />

        <TextInput
          source="description"
          label="Description"
          multiline
          rows={3}
          fullWidth
        />

        <TextInput
          source="industry"
          label="Industry"
          placeholder="e.g., Cleaning Services, Lawn Care"
          fullWidth
        />

        <SelectInput
          source="enterpriseId"
          label="Enterprise"
          optionText="name"
          optionValue="id"
          validate={[{ required: 'Enterprise is required' }]}
          fullWidth
        />

        <NumberInput
          source="defaultRoyaltyRate"
          label="Default Royalty Rate (%)"
          helperText="Percentage that franchisees pay (e.g., 5 for 5%)"
          step={0.1}
          fullWidth
        />
      </SimpleForm>
    </Edit>
  );
};
